import * as yup from "yup";
import BaseForm from "../../../../../../../shared/components/form/BaseForm";
import FormInput from "../../../../../../../shared/components/input/FormInput";
import FormTextarea from "../../../../../../../shared/components/textarea/FormTextarea";

const CreateRoleForm = ({ onSubmitHandler }) => {
  const validationSchema = yup.object({
    code: yup.string().required("El código del rol es obligatorio"),
    name: yup.string().required("El nombre del rol es obligatorio"),
  });

  const defaultValues = {
    code: "",
    name: "",
    description: "",
  };

  return (
    <BaseForm
      validationSchema={validationSchema}
      defaultValues={defaultValues}
      onSubmitHandler={onSubmitHandler}
    >
      <div className="flex flex-row justify-between gap-x-4">
        <div className="w-1/2">
          <FormInput name="code" label="Código" required />
        </div>
        <div className="w-1/2">
          <FormInput name="name" label="Nombre" required />
        </div>
      </div>
      <FormTextarea name="description" label="Descripción" />
    </BaseForm>
  );
};

export default CreateRoleForm;
